import React from 'react';
import { MdVerified, MdSchedule, MdError } from 'react-icons/md';

function VerifiedBadge({ status, size = 'sm' }) {
  if (status === 'verified') {
    const sizeClass = size === 'lg' ? 'text-xl' : size === 'md' ? 'text-lg' : 'text-sm';
    return (
      <span className={`inline-flex items-center gap-0.5 text-blue-500 ${sizeClass}`} title="Identity Verified" data-testid="verified-badge">
        <MdVerified />
      </span>
    );
  }

  if (status === 'submitted' || status === 'pending') {
    const sizeClass = size === 'lg' ? 'text-xl' : size === 'md' ? 'text-lg' : 'text-sm';
    return (
      <span className={`inline-flex items-center gap-0.5 text-amber-400 ${sizeClass}`} title="Verification Pending" data-testid="pending-badge">
        <MdSchedule />
      </span>
    );
  }

  if (status === 'rejected') {
    const sizeClass = size === 'lg' ? 'text-xl' : size === 'md' ? 'text-lg' : 'text-sm';
    return (
      <span className={`inline-flex items-center gap-0.5 text-red-400 ${sizeClass}`} title="Verification Rejected" data-testid="rejected-badge">
        <MdError />
      </span>
    );
  }

  // Unverified or no status — grayed out badge
  const sizeClass = size === 'lg' ? 'text-xl' : size === 'md' ? 'text-lg' : 'text-sm';
  return (
    <span className={`inline-flex items-center gap-0.5 text-gray-300 ${sizeClass}`} title="Not Yet Verified" data-testid="unverified-badge">
      <MdVerified />
    </span>
  );
}

export default VerifiedBadge;
